const componentStyles = (theme) => ({
  header: {
    position: "relative",
    backgroundColor: theme.palette.header.main,
    // The stat cards render inside this header, so this padding is the
    // clearance below them. Views pull the next section up by -6rem, leaving
    // a 2rem gap -- do not reduce this to 6rem or that section lands on top
    // of the last row of cards.
    paddingBottom: "8rem",
  },
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  gridItem: {
    display: "flex",
    alignItems: "center",
  },
  buttonRoot: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.white.main,
    borderColor: theme.palette.white.main,
    "&:first-of-type": { marginRight: ".75rem" },
    "&:hover": {
      backgroundColor: theme.palette.white.main,
      borderColor: theme.palette.white.main,
      color: theme.palette.dark.main,
    },
  },
  displayInlineBlock: {
    display: "inline-block",
  },
  mb0: {
    marginBottom: 0,
  },
  breadcrumbRoot: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      marginLeft: "1.5rem",
      display: "inline-block",
    },
  },
  breadcrumbOl: {
    background: "transparent",
    marginBottom: 0,
  },
  // These sit on the header background, which is now the tenant primary at
  // full strength -- anywhere from #000000 to hot pink. Hardcoded white only
  // worked while the header was a fixed color.
  breadcrumbLi: {
    "& a": {
      color: theme.palette.header.contrastText,
      opacity: 0.8,
      textDecoration: "none",
      fontWeight: 600,
      "&:hover": {
        color: theme.palette.header.contrastText,
        opacity: 1,
        textDecoration: "none",
      },
    },
  },
  breadcrumbSeparator: {
    color: theme.palette.header.contrastText,
    opacity: 0.6,
  },
  breadcrumbActive: {
    fontSize: ".875rem",
    color: theme.palette.header.contrastText,
    opacity: 0.8,
    fontWeight: 600,
  },
  textWhite: {
    color: theme.palette.header.contrastText,
  },
});

export default componentStyles;
